<script lang="ts">
  export let placeholder = '';
  export let value = '';
  export let disabled = false;
</script>

<div>
  <textarea bind:value {placeholder} rows="5" {disabled} />
</div>

<style>
  div {
    display: flex;
  }

  textarea {
    padding: 10px 14px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
      Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 14px;
    border-radius: 8px;
    background: var(--loop-textareaBackground);
    color: var(--loop-foreground);
    border: solid transparent 1px;
    resize: none;
    outline: none;
    transition: all 0.3s;
    flex-grow: 1;
  }

  textarea:not(:disabled):hover,
  textarea:not(:disabled):focus {
    border: solid var(--loop-textareaBorder) 1px;
  }
</style>
